import gql from 'graphql-tag';

export const CREATE_TICKET = gql`
    mutation createTicketMutation($input: CreateTicketInput!) {
        createTicket(input: $input) {
            id
			description
			identifier
			assignee {
				id
				firstname
				lastname
				destroyed
			}
			type
			priority
			status
			ticketWorkflowStatus
			archived
			visibleToDrivers
			photoRequired
			autoIncludeOnNextRun
			notifyWhenResolved
        }
    }
`;
